import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DocumentAttachment, detectPreviewKind, FilePreviewKind } from '@mmlogic/components';
import { ApiClientService } from 'src/app/core/services/api-client.service';

/**
 * Renders whichever file(s) mrd-layout-section reported via mrdAttachments — the
 * component itself never fetches or previews anything (see TASK-0165 /
 * FINDING-0111). Signed URL is only resolved for the active attachment, not
 * eagerly for every entry when the record loads.
 *
 * commons.document always reports exactly one attachment; commons.invoice/
 * commons.email (TASK-0199/TASK-0208) can report several, hence the picker row
 * (only shown when there's more than one) and `activeIndex` state below.
 */
@Component({
    selector: 'app-document-preview',
    templateUrl: './document-preview.component.html',
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class DocumentPreviewComponent implements OnChanges {
  @Input() attachments: DocumentAttachment[] = [];

  activeIndex = 0;
  resolvedUrl: string | null = null;
  kind: FilePreviewKind | null = null;
  error = false;

  constructor(private api: ApiClientService) {}

  get attachment(): DocumentAttachment | null {
    return this.attachments[this.activeIndex] ?? null;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['attachments']) return;
    this.activeIndex = 0;
    this.resolveActive();
  }

  selectAttachment(index: number): void {
    if (index === this.activeIndex) return;
    this.activeIndex = index;
    this.resolveActive();
  }

  private resolveActive(): void {
    const attachment = this.attachment;
    this.resolvedUrl = null;
    this.error = false;
    this.kind = attachment ? detectPreviewKind(attachment.mimeType, attachment.fileName) : null;
    if (attachment && this.kind !== 'unsupported') {
      this.api.getDownloadLink(attachment.href).subscribe({
        next: url => { this.resolvedUrl = url; },
        error: err => {
          this.error = true;
          console.error('[document-preview] laden mislukt', attachment.href, err);
        },
      });
    }
  }

  download(): void {
    const attachment = this.attachment;
    if (!attachment) return;
    this.api.getDownloadLink(attachment.href).subscribe(url => window.open(url, '_blank', 'noopener,noreferrer'));
  }
}
